import { render, staticRenderFns } from "./verify-pwd.vue?vue&type=template&id=4cec779a&scoped=true&"
import script from "./verify-pwd.vue?vue&type=script&lang=js&"
export * from "./verify-pwd.vue?vue&type=script&lang=js&"
import style0 from "./verify-pwd.vue?vue&type=style&index=0&id=4cec779a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cec779a",
  null
  
)

export default component.exports